import { render } from "./QR.vue?vue&type=template&id=2bb15dce&scoped=true"
import script from "./QR.vue?vue&type=script&lang=js"
export * from "./QR.vue?vue&type=script&lang=js"

import "./QR.vue?vue&type=style&index=0&id=2bb15dce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb15dce"]])

export default __exports__